import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { SendingEmailRow } from "../sendingEmailsViewConfig";

export const EmailDomainCell = memo(
    ({ row }: CellContext<ViewTableFeatures, SendingEmailRow, string>) => (
        <ViewTableCell>{row.original.domain}</ViewTableCell>
    ),
);
